/**
 * Generated runtime TestId mirror for frontend/src/features/outbound-connectors/components/forms/ConnectorConfigForm.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const ConnectorConfigFormTestIds = {
  clientSecretRef: "client-secret-ref",
  passwordSecretRef: "password-secret-ref",
  selectAuthType: "select-auth-type",
  tokenSecretRef: "token-secret-ref"
} as const;
